
import { SecuredClient } from 'Core/Api/SecuredClient';
import { GetAllPlayersByFilterCommandRequest, GetPlayerGamesByUserIdAndFilterCommandRequest, SlimPlayer } from '../../../Core/Api/Api';
import TableRequest from '../../../Core/TableUtility/Models/TableRequest';
import ITableDataResponse from '../../Forms/DataGrid/SimpleTable/Models/ITableDataResponse';

// Types matching the backend PlayerDetailResponse DTOs
// These will be auto-generated when NSwag regenerates Api.ts

export interface PlayerHeaderInfo {
    username?: string;
    email?: string;
    joinDate?: string;
    rankName?: string;
    rankScore?: number;
    highestRating?: number;
    friendsCount?: number;
    achievementsCompleted?: number;
    totalAchievements?: number;
    vsHighScore?: number;
    singleModeBestTime?: number | null;
    lastActivity?: string;
    isOnline?: boolean;
}

export interface PlayerAchievementItem {
    title?: string;
    description?: string;
    grantedAt?: string;
}

export interface DifficultyBreakdown {
    difficulty?: string;
    gamesPlayed?: number;
    avgErrors?: number;
    avgHints?: number;
    bestTime?: number;
    avgTime?: number;
    worstTime?: number;
}

export interface SingleModeStats {
    gamesAttempted?: number;
    gamesCompleted?: number;
    gamesFailed?: number;
    byDifficulty?: DifficultyBreakdown[];
}

export interface VsModeStats {
    gamesPlayed?: number;
    wins?: number;
    losses?: number;
    highestScore?: number;
    lowestScore?: number;
    avgScore?: number;
    avgHints?: number;
    avgErrors?: number;
    avgInputs?: number;
}

export interface DailyChallengeStats {
    gamesPlayed?: number;
    gamesCompleted?: number;
    gamesFailed?: number;
    bestTime?: number | null;
    worstTime?: number | null;
    avgScore?: number;
    avgHints?: number;
    avgErrors?: number;
}

export interface PurchaseItem {
    productName?: string;
    purchaseDate?: string;
    amount?: number;
}

export interface PlayerDetailResponse {
    header?: PlayerHeaderInfo;
    achievements?: PlayerAchievementItem[];
    singleModeStats?: SingleModeStats;
    vsModeStats?: VsModeStats;
    vsBotStats?: VsModeStats;
    dailyChallengeStats?: DailyChallengeStats;
    purchases?: PurchaseItem[];
}

export interface GetPlayerDetailsByUserIdCommandResponse {
    success?: boolean;
    playerDetail?: PlayerDetailResponse;
}

export class PlayerHandler {
    constructor(props?: any) { }

    GetData(tableRequest: TableRequest): Promise<ITableDataResponse<SlimPlayer>> {
        return this.getPlayerListForTable(tableRequest);
    }

    async getPlayerListForTable(request: TableRequest): Promise<ITableDataResponse<SlimPlayer>> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        try {
            return await client.getPlayersByFilter(new GetAllPlayersByFilterCommandRequest(request));
        } finally {
            client.showLoading = false;
        }
    }

    async getPlayerDetails(userId: string): Promise<GetPlayerDetailsByUserIdCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const response = await client.getPlayerDetailsByUserId(userId);
        return response as any;
    }

    async getPlayerGames(request: GetPlayerGamesByUserIdAndFilterCommandRequest) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        return client.getPlayerGamesByUserId(request);
    }
}
